import { useNavigate, useParams } from "react-router-dom";
import { validateId } from "utils/validators";
import { useOrganizationDetailsQuery } from "@ticketingplatform/api/dist/organization";
import { ROUTE_PATHS } from "const/paths";

import { useOrganizationDelete } from "../OrganizationList/hooks";

import { UseOrganizationDetailsReturnType } from "./types";

export const useOrganizationDetails = (): UseOrganizationDetailsReturnType => {
  const { id } = useParams();
  const navigate = useNavigate();
  const validatedId = validateId(id);
  const { handleConfirm } = useOrganizationDelete();

  const { data, loading } = useOrganizationDetailsQuery({
    variables: { id: validatedId },
    onError: () => navigate(ROUTE_PATHS.OrganizationsList),
  });

  const deleteOrganization = async () => {
    await handleConfirm(validatedId);
    navigate(ROUTE_PATHS.OrganizationsList);
  };

  const name = data?.organization?.name || "";

  return {
    initialValues: { input: { name } },
    id: validatedId,
    loading,
    deleteOrganization,
  };
};
